import * as React from 'react';

function SvgMailIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
    <circle cx={10} cy={10} r={10} fill="#DF4046" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M9.926 6h.22M4.976 6.028h10.048c.586 0 .976.396.976.99v7.021c0 .594-.39.99-.976.99H4.976c-.586 0-.976-.396-.976-.99V7.017c0-.593.39-.989.976-.989"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m15.5 6.528-5.5 5.5-5.5-5.5M12 10.028l4 4M8 10.028l-4 4"
    />
  </svg>)
}
export default SvgMailIcon;
